"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPodcastSeasonProperty = exports.podcastSeasonPropertyDefinition = void 0;
exports.podcastSeasonPropertyDefinition = {
    view: { label: 'Season' },
    constraints: [
        {
            name: 'stencils',
            argument: ['podcast-season'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'podcast-season',
};
const isPodcastSeasonProperty = (prop) => {
    return prop.name === exports.podcastSeasonPropertyDefinition.name;
};
exports.isPodcastSeasonProperty = isPodcastSeasonProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9kY2FzdC1zZWFzb24ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9wb2RjYXN0LXNlYXNvbi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUU7SUFDekIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxnQkFBZ0IsQ0FBQztTQUM3QjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxnQkFBZ0I7Q0FDUyxDQUFBO0FBSTFCLE1BQU0sdUJBQXVCLEdBQUcsQ0FBQyxJQUFrQixFQUFpQyxFQUFFO0lBQzNGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx1Q0FBK0IsQ0FBQyxJQUFJLENBQUE7QUFDM0QsQ0FBQyxDQUFBO0FBRlksUUFBQSx1QkFBdUIsMkJBRW5DIn0=